module.exports = __webpack_public_path__ + "assets/measure_expenses_over_time.7902408c.svg";